module.exports = __webpack_public_path__ + "fonts/fa-regular-400.31e6727.woff2";